/**
 * ngTable: Table + Angular JS
 *
 * @author Vitalii Savchuk <esvit666@gmail.com>
 * @url https://github.com/esvit/ng-table/
 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
 */

import { IDefaults } from './public-interfaces';

/**
 * Default values for ngTable
 * @ngdoc object
 */
export var ngTableDefaults : IDefaults = {
    params: {},
    settings: {}
};


// WEBPACK FOOTER //
// ./~/angular1-template-loader!./src/core/ngTableDefaults.ts